import React , { useState, useContext} from "react";
import Button from "../../atoms/button/button";
import ModalConocerTalento from "../../molecules/modal-conocer-talento/modalConocerTalento";
import { isMobile } from "../../../utils/helpers";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"

// Context //
import TalentsContext from "../../../contexts/talentsContext";

// Styles //
import "./openTalents.scss";

interface OpenTalentsProps {
    nombres: string;
    apellidos: string;
    numeroDocumento: number;
    nivelEducativo: Array<any>;
    municResidencia: any;
    handleChange: any;
    talentsSelectedIds: any;
}

const OpenTalents = (props: OpenTalentsProps) => {
    const {
        nombres,
        apellidos,
        numeroDocumento,
        nivelEducativo,
        municResidencia,
        handleChange,
        talentsSelectedIds
    } = props;

    // Bloque creado para el modal //
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};
    // Bloque creado para el modal //

    const { talents } = useContext(TalentsContext);
    const getTalentValues = (numeroDocumento) => {
        const selectedTalents = talents.filter(talent => numeroDocumento.includes(talent.numeroDocumento));
        localStorage.setItem("talentsSelected",JSON.stringify(selectedTalents));
    }

    const educationalLevelOrder = ["Doctorado","Maestría","Universitario","Especialista","Tecnólogo","Técnico"]
    const educationalLevelOrganize = nivelEducativo.sort((a, b) => educationalLevelOrder.indexOf(a.nivelAcademico) - educationalLevelOrder.indexOf(b.nivelAcademico));
    const areaProfesionalFixed = Array.from(new Set(educationalLevelOrganize.map(obj => obj.areaProfesional))).map(areaProfesional => {
        return educationalLevelOrganize.find(obj => obj.areaProfesional === areaProfesional);
    });

    const nameAndLastNameFixed = (nombres, apellidos) => {
        
        const name = nombres.toLowerCase().split(' ');
        const nameFixed = name.map(name => name.charAt(0).toUpperCase() + name.slice(1));

        const lastName = apellidos.toLowerCase().split(' ');
        const lastNameFixed = lastName.map(lastName => lastName.charAt(0).toUpperCase() + lastName.slice(1));

        return nameFixed.join(" ") + " " + lastNameFixed.join(" ");
    }

    return (

        <div 
            className={
                talentsSelectedIds.length > 0 && talentsSelectedIds.includes(numeroDocumento)
                ? `open-talent__talentSelected`
                : `open-talent`
            }>
            <div className="open-talent__checkBox">
                <input
                    type="checkbox"
                    checked={talentsSelectedIds.includes(numeroDocumento)}
                    onChange={handleChange}
                    value={numeroDocumento}
                />
            </div>
            <div className="open-talent__container">
                <div className="open-talent__container__top"> 
                    <div className="open-talent__container__header">
                        <div className="open-talent__container__header__title">
                            <h3>{nameAndLastNameFixed(nombres, apellidos)}</h3>
                        </div>
                        {!isMobile() && (
                            <div>
                                <Button
                                    id={`${wordFixerForGTM(nivelEducativo?.map(i => i.tituloProfesional).toString())}`}
                                    onClickAction={() => {
                                        setIsOpenModal(true);
                                        getTalentValues(numeroDocumento);
                                    }}
                                    type="button"
                                    text={'CONOCER TALENTO'}
                                    classname={`a-button__magenta gtm_encontrar_talento_solicitar_${nivelEducativo?.map(i => i.tituloProfesional)}`}
                                    isDisabled={talentsSelectedIds.length > 0}
                                />
                            </div>
                        )}
                    </div>
                    {educationalLevelOrganize?.slice(0, 2).map((item, index) => (
                        <div className="open-talent__container__description">
                            <p>
                                <span>{item.nivelAcademico}</span>
                            </p>
                            <p>
                                {item.tituloProfesional}
                            </p>
                        </div>
                    ))}
                </div>
                
                <div className="open-talent__container__bottom">
                    <div className="open-talent__container__bottom__item">
                        <span>
                            <i className="icon-map-marker-alt"></i>
                            Ubicación:&nbsp;
                            <p>{municResidencia}</p>
                        </span>
                        <span>
                            <i className="icon-briefcase"></i> 
                            Experiencia:&nbsp;
                            <p>{areaProfesionalFixed?.map( i => i.areaProfesional )}</p>
                        </span>
                    </div>
                </div>
            </div>
            {isMobile() && (
                <div className="open-talent__mobileButton">
                    <Button
                        id={`${wordFixerForGTM(nivelEducativo?.map(i => i.tituloProfesional).toString())}`}
                        onClickAction={() => {
                            setIsOpenModal(true)
                            getTalentValues(numeroDocumento);
                        }}
                        type="button"
                        text={'CONOCER TALENTO'}
                        classname={`dimensions gtm_encontrar_talento_solicitar_${nivelEducativo?.map(i => i.tituloProfesional)}`}
                        isDisabled={talentsSelectedIds.length > 0}
                        />
                </div>
            )}
            {isOpenModal && (
                <ModalConocerTalento
                    showModal={isOpenModal} 
                    onClose={closeModal}
                    talentsSelectedIds={talentsSelectedIds.length}
                />
            )}
        </div>
    );
};

export default OpenTalents;
